module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-teatopics-intro-card1.1@2x.d7c60a02.jpg";